"use strict";
exports.__esModule = true;
exports.isDate = exports.isNumber = exports.isURL = exports.isValidDomain = exports.isValidString = void 0;
var isValidString = function (value) {
    return typeof value === 'string' && value.trim().length > 0;
};
exports.isValidString = isValidString;
var isValidDomain = function (value) {
    var domainRegex = /^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,}$/i;
    return domainRegex.test(value);
};
exports.isValidDomain = isValidDomain;
var isURL = function (value) {
    try {
        new URL(value);
        return true;
    }
    catch (err) {
        return false;
    }
};
exports.isURL = isURL;
var isNumber = function (value) {
    return typeof value === 'number' && !isNaN(value);
};
exports.isNumber = isNumber;
var isDate = function (value) {
    return value instanceof Date;
};
exports.isDate = isDate;
